export default "__VITE_ASSET__BD9g6KHh__"